module.exports = __webpack_public_path__ + "img/banner-contact-arrow.224f4dc1.svg";